import { DataTransferUpIcon } from '@synoptic/ui-kit/icons/react/data-transfer-up.tsx';
import { InfoCircleIcon } from '@synoptic/ui-kit/icons/react/info-circle.tsx';
import { UserCircleIcon } from '@synoptic/ui-kit/icons/react/user-circle.tsx';
import { CustomTargetsDataFragmentFragment } from '@/__generated__/graphql.ts';
import {
  customTargetItem,
  customTargetsContainer,
} from '@/routes/_app.p.streams_.$id/stream-banner/custom-stream-components/custom-targets-data.css.ts';

export const CustomTargetsData = ({
  customTargetsData,
  price,
}: {
  customTargetsData: NonNullable<CustomTargetsDataFragmentFragment>;
  price: number;
}) => {
  return (
    <div className={customTargetsContainer}>
      <div className={customTargetItem}>
        <DataTransferUpIcon />${price} for {customTargetsData.stepSize} targets
      </div>
      <div className={customTargetItem}>
        <InfoCircleIcon />
        {customTargetsData.targetTypeInstruction}
      </div>
      {customTargetsData.maxTotalTargets ? (
        <div className={customTargetItem}>
          <UserCircleIcon />
          Up to {customTargetsData.maxTotalTargets}
        </div>
      ) : null}
    </div>
  );
};
